<template>
  <NavBar ref="navbar" :course="course" :user="user"/>
  <router-view :navVh="navVh"></router-view>
  <br>
  <div class="version-number">v2.2.7</div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import { auth } from './main';
import { onAuthStateChanged } from 'firebase/auth';

export default {
  name: 'App',
  components: {
    NavBar
  },
  data() {
    return {
      course: null,
      user: null,
      navVh: null,
    }
  },
  created() {
    onAuthStateChanged(auth, user => {
      if(user){
        this.user = user.email;
      } else {
        this.user = null;
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      let navbarHeightInPx = this.$refs.navbar.$el.offsetHeight;
      let viewportHeightInPx = window.innerHeight;
      let navbarHeightInVh = (navbarHeightInPx / viewportHeightInPx) * 100;
      this.navVh = navbarHeightInVh;
    });
  }
}
</script>

<style>
.version-number {
  position: fixed;
  bottom: 10px;
  right: 20px;
  font-size: 0.9em;
  color: #888;
  z-index: 1000;
}
</style>
